import { default as Loader } from './Loader';

export {
  Loader
};



// WEBPACK FOOTER //
// ./src/components/index.js